// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"359":"51b50ca3c29c8a28b91e","897":"4f4385284e7ed96aec3b"}[chunkId] + ".js";
};